// Postgres DATE columns come back over JSON as UTC-midnight ISO strings
// (e.g. "2026-07-06T00:00:00.000Z"). Formatting in the browser's local
// timezone would shift the date back a day for negative UTC offsets, so
// this always reads the date parts out in UTC.
export function formatDate(isoString) {
  if (!isoString) return "";

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}
